export class InvalidPasswordError extends Error {
  constructor(message) {
    super(message);
  }
}

